<template>
  <!-- <page-banner :pageNumber="6" /> -->
  <div class="mainContainer">
    <img src="../../../assets/images/pages/zhuanti/dqjs.jpg" alt="党群建设" class="banner" />
    <SwitchPageTabbar active-color="#E50012">
      <nuxt-link to="/dqjs/xxgcddesdjs">学习贯彻党的二十大精神</nuxt-link>
      <nuxt-link to="/dqjs/djll">党建理论</nuxt-link>
      <nuxt-link to="/dqjs/djdt">党建动态</nuxt-link>
      <nuxt-link to="/dqjs/dyfc">党员风采</nuxt-link>
      <nuxt-link to="/dqjs/ljjs">廉洁建设</nuxt-link>
      <nuxt-link to="/dqjs/zgzj">职工之家</nuxt-link>
      <nuxt-link to="/dqjs/qnzs">青年之声</nuxt-link>
    </SwitchPageTabbar>
    <listCoverInline :list="list" toPath="/dqjs/xq/" :emptyTxt="_path2Name[Router.path]"></listCoverInline>
    <pagination :total="state.total" :pageSize="state.pageSize" @changePage="changePage"></pagination>
  </div>
</template>

<script setup>
const Router = useRoute()
import SwitchPageTabbar from "../../../components/switchPageTabbar";
import {getAListOfPartyAndMassBuilding} from "../../../apis/dqjs";
import Pagination from "../../../components/pagination";
//
let state = reactive({
  page: 1,
  pageSize: 10,
  contentTypeId: 1
})

let _path2Id = {
  // 1.学习贯彻党的二十大精神，2.党建理论，3.党建动态，4.党员风采，5.廉洁建设，6.职工之家 7.青年之声
  '/dqjs/xxgcddesdjs': 1,
  '/dqjs/djll': 2,
  '/dqjs/djdt': 3,
  '/dqjs/dyfc': 4,
  '/dqjs/ljjs': 5,
  '/dqjs/zgzj': 6,
  '/dqjs/qnzs': 7,
}
state.contentTypeId = _path2Id[Router.path]

let _path2Name = {
  '/dqjs/xxgcddesdjs': '学习贯彻党的二十大精神',
  '/dqjs/djll': '党建理论',
  '/dqjs/djdt': '党建动态',
  '/dqjs/dyfc': '党员风采',
  '/dqjs/ljjs': '廉洁建设',
  '/dqjs/zgzj': '职工之家',
  '/dqjs/qnzs': '青年之声',
}


let list = ref([])
const listRes = await useAsyncData('getAListOfPartyAndMassBuilding',
    () => getAListOfPartyAndMassBuilding({...state}),
    // { watch: [state] }
)
if (listRes.data.value.code !== 200) {
  throw createError({statusCode: listRes.data.value.code, statusMessage: encodeURIComponent("getAListOfPartyAndMassBuilding")})
} else {
  state.total = listRes.data.value.data.total;
  list.value = listRes.data.value.data.list;
}

watch(listRes.data, (value => {
  if (value.code !== 200) {
    throw createError({statusCode: value.code, statusMessage: encodeURIComponent("getAListOfPartyAndMassBuilding")})
  } else {
    state.total = value.data.total;
    list.value =value.data.list;
  }
}))

function changePage(page) {
  state.page = page
  listRes.refresh()
}
</script>

<style scoped lang="scss">
.mainContainer {
  .banner {
    width: 1300px;
    height: 129.07px;
  }
  .switchPage {
    margin-top: 32px;
  }
}
</style>